import script from "./BillingFAQAccordion.vue?vue&type=script&setup=true&lang=js"
export * from "./BillingFAQAccordion.vue?vue&type=script&setup=true&lang=js"

import "./BillingFAQAccordion.vue?vue&type=style&index=0&id=3a8aac18&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3a8aac18"]])

export default __exports__